module.exports = ".modal-body {\n  padding: 25px 58px 30px 58px; }\n\n.modal-footer button {\n  margin: 0 auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/info-modal/info-modal.component.scss
// module id = ./src/app/shared/components/info-modal/info-modal.component.scss
// module chunks = main